import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
import { EncryptClientID, Encryption } from '../../utils/commonfunction';
var axios = require('axios');
function getAlertNotification(clientID) {
   let encryptClientID=Encryption(clientID?.toString())
    return Networking.GetApi(`${ApiValues.alertNotification}?clientID=${encryptClientID}`).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }
    });

}
export default getAlertNotification
